import * as context from './context';
import getQueryParam from './getQueryParam';

export default function getNextUrl() {
  if (typeof window === 'undefined') {
    return '';
  }

  return (
    context.getKey('nextUrl') ||
    getQueryParam('next') ||
    window.location.pathname
  );
}
